module.exports = __webpack_public_path__ + "static/banner-d63da91140794f2d582bfb8170c7bf22.jpg";